import axios from "axios";
const defaultUnsubscriptionBackgroungImage = require("../../assets/images/unsubscription.png");
const defaultBackgroungImage = require("../../assets/images/bg.png");
const defaultBackgroungImageMobile = require("../../assets/images/mobileBg.png");
const defaultLogo = require("../../assets/images/logo.png");

const getSiteDetails = async (token) => {
  try {
    localStorage.setItem("token", token);
    const result = await axios({
      method: "get",
      url: "/api/cologuard/getSiteDetails",
      headers: { "x-access-token": token },
    });
    if (result.data.status === 1) {
      localStorage.setItem("statusDescription", "");
      let organizationId = result.data.organizationId;
      localStorage.setItem("organizationId", organizationId);
      let careCenterId = result.data.careCenterId;
      localStorage.setItem("careCenterId", careCenterId);
      localStorage.setItem("siteName", result.data.siteName);
      let unsubscriptionImagePath = `${process.env.PUBLIC_URL}/org_assets/org-${organizationId}`;
      if (organizationId == 194 && careCenterId == 431) {
        unsubscriptionImagePath =
          unsubscriptionImagePath + `/care_centers/cc-${careCenterId}`;
      }
      unsubscriptionImagePath = unsubscriptionImagePath + "/unsubscription.png";
      return unsubscriptionImagePath;
    }
  } catch (error) {
    const unAuthCode = 401;
    if (error.response.status === unAuthCode) {
      if (error.response.data.status === 0) {
        localStorage.setItem(
          "statusDescription",
          error.response.data.statusDescription
        );
      } else {
        localStorage.setItem("statusDescription", "");
      }
    }
    return defaultUnsubscriptionBackgroungImage;
  }
};

const checkImageFileExist = async (imagePath) => {
  let finalImage = false;
  try {
    let result = await axios({
      method: "get",
      url: imagePath,
    });
    if (result.status === 200) {
      if (result.headers["content-type"].includes("image")) {
        finalImage = imagePath;
      }
    }
  } catch (error) {
    console.log("File Does not exist");
  }
  return finalImage;
};

const checkBackgroundImageExist = async (organizationId, careCenterId) => {
  let orgBackgroungImagePath = `${process.env.PUBLIC_URL}/org_assets/org-${organizationId}`;
  let orgBackgroungImagePathMobile = `${process.env.PUBLIC_URL}/org_assets/org-${organizationId}`;
  let logoImagePath = `${process.env.PUBLIC_URL}/org_assets/org-${organizationId}`;
  if (organizationId == 194 && careCenterId == 431) {
    orgBackgroungImagePath =
      orgBackgroungImagePath + `/care_centers/cc-${careCenterId}`;
    orgBackgroungImagePathMobile =
      orgBackgroungImagePathMobile + `/care_centers/cc-${careCenterId}`;
    logoImagePath = logoImagePath + `/care_centers/cc-${careCenterId}`;
  }
  logoImagePath = logoImagePath + "/logo.png";
  orgBackgroungImagePath = orgBackgroungImagePath + "/bg.png";
  orgBackgroungImagePathMobile = orgBackgroungImagePathMobile + "/mobileBg.png";
  let obj = {
    desktop: defaultBackgroungImage,
    mobile: defaultBackgroungImageMobile,
    logo: defaultLogo,
  };
  let bgExist = await checkImageFileExist(orgBackgroungImagePath);
  if (bgExist) {
    obj["desktop"] = bgExist;
  }
  let bgMobileExist = await checkImageFileExist(orgBackgroungImagePathMobile);
  if (bgMobileExist) {
    obj["mobile"] = bgMobileExist;
  }
  let logoExist = await checkImageFileExist(logoImagePath);
  if (logoExist) {
    obj["logo"] = logoExist;
  }
  return obj;
};

const commonBackgroundImageHelper = async (
  organizationId,
  careCenterId,
  setLoading,
  setDobBackgroundImage,
  setDobMobileBackgroundImage,
  setImageSrc
) => {
  let dobBackgroundImages = await checkBackgroundImageExist(
    organizationId,
    careCenterId
  );
  setLoading(false);
  setDobBackgroundImage(dobBackgroundImages.desktop);
  setDobMobileBackgroundImage(dobBackgroundImages.mobile);
  setImageSrc(dobBackgroundImages.logo);
};

const handleStoreAlreadyDoneDetails = async (body) => {
  let flag = false;
  try {
    let result = await axios({
      method: "post",
      url: "/api/cologuard/storeAlreadyDoneDetails",
      headers: { "x-access-token": `${localStorage.getItem("token")}` },
      data: { questions: body },
    });
    if (result.data.status === 1) {
      flag = true;
    }
  } catch (error) {
    console.error("Error storing already done details:", error);
    flag = false;
  }
  return flag;
};

const handleStoreScreeningScheduledDetails = async (body) => {
  let flag = false;
  try {
    let result = await axios({
      method: "post",
      url: "/api/cologuard/storeScreeningScheduledDetails",
      headers: { "x-access-token": `${localStorage.getItem("token")}` },
      data: { questions: body },
    });
    if (result.data.status === 1) {
      flag = true;
    }
  } catch (error) {
    console.error("Error storing screening scheduled details:", error);
    flag = false;
  }
  return flag;
};

export {
  getSiteDetails,
  checkBackgroundImageExist,
  commonBackgroundImageHelper,
  handleStoreAlreadyDoneDetails,
  handleStoreScreeningScheduledDetails,
};
